// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WuuYe","footer":"styles_footer__2nGdJ","passCodeTooltip":"styles_passCodeTooltip__1MBhv"};